/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  jQuery(document).ready(function() {
    // Select the element you want to toggle the class on click
    jQuery('.footer__block.footer__block--menu.box_1 .footer__block__title').click(function() {
      // Toggle the class 'active' on click
      jQuery(this).toggleClass('active');
      jQuery('.footer__block.footer__block--menu.box_1 ul.footer__quicklinks').slideToggle();
    });

    // Select the element you want to toggle the class on click
    jQuery('.footer__block.footer__block--menu.box_2 .footer__block__title').click(function() {
      // Toggle the class 'active' on click
      jQuery(this).toggleClass('active');
      jQuery('.footer__block.footer__block--menu.box_2 ul.footer__quicklinks').slideToggle();
    });

    // Select the element you want to toggle the class on click
    jQuery('.footer__block.footer__block--menu.box_3 .footer__block__title').click(function() {
      // Toggle the class 'active' on click
      jQuery(this).toggleClass('active');
      jQuery('.footer__block.footer__block--menu.box_3 ul.footer__quicklinks').slideToggle();
    });
  });
  // Add custom code below this line


  /* code for product page specification */


 //  $(".btn_0").click(function(){   
   
 //   $( "#modal_0 .popRowSet" ).tabs({
 //  active: 0
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });
 //  });
  

 //   $(".btn_1").click(function(){
  
 //  $( "#modal_1 .popRowSet" ).tabs({
 //  active: 1
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });


 //   $(".btn_2").click(function(){
  
 //  $( "#modal_2 .popRowSet" ).tabs({
 //  active: 2
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });

 //  $(".btn_3").click(function(){

 //  $( "#modal_3 .popRowSet" ).tabs({
 //  active: 3
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });


 //  $(".btn_4").click(function(){
  
 //  $( "#modal_4 .popRowSet" ).tabs({
 //  active: 4
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });


 //       $(".btn_5").click(function(){
  
 // $( "#modal_5 .popRowSet" ).tabs({
 //  active: 5
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });



 //  $(".btn_6").click(function(){
  
 //  $( "#modal_6 .popRowSet" ).tabs({
 //  active: 6
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });

 //  $(".btn_7").click(function(){
  
 //  $( "#modal_7 .popRowSet" ).tabs({
 //  active: 7
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });

 //  $(".btn_8").click(function(){
  
 //  $( "#modal_8 .popRowSet" ).tabs({
 //  active: 8
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });

 //  $(".btn_9").click(function(){
  
 //  $( "#modal_9 .popRowSet" ).tabs({
 //  active: 9
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });

 //  $(".btn_10").click(function(){
  
 //  $( "#modal_10 .popRowSet" ).tabs({
 //  active: 10
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });
 //  $(".btn_11").click(function(){
  
 //  $( "#modal_11 .popRowSet" ).tabs({
 //  active: 11
 //  });

 //      $(".accordion_head").click(function () {
 //        if ($('.accordion_body').is(':visible')) {
 //            $(".accordion_body").slideUp(300);
 //            $(".plusminus").text('+');
 //        }
 //        if ($(this).next(".accordion_body").is(':visible')) {
 //            $(this).next(".accordion_body").slideUp(300);
 //            $(this).children(".plusminus").text('+');
 //        } else {
 //            $(this).next(".accordion_body").slideDown(300);
 //            $(this).children(".plusminus").text('-');
 //        }
 //    });


 //  });
  





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
$(function() {
  $("#tabs").tabs().addClass("ui-tabs-vertical ui-helper-clearfix");
  $(".accordion_faq").accordion({
    heightStyle: "content",
    collapsible: true,
    active: false
  });
});